import React, { useState, useEffect } from 'react';
import {
  Divider,
  Tab,
  TabList,
  type SelectTabData,
  type SelectTabEvent,
} from '@fluentui/react-components';
import { useLocation } from 'react-router-dom';
import { PersonRegular, TimerRegular } from '@fluentui/react-icons';
import Personaldata from './personaldata';
import Timetracking from './timetracking';
import { ROLES } from '../../constants/roles';

const ROLE_STORAGE_KEY = 'userPersonalRole';
const getCurrentRole = (): string[] => {
  try {
    const raw = sessionStorage.getItem(ROLE_STORAGE_KEY);
    console.log('DetailView getCurrentRole - raw sessionStorage:', raw);
    if (!raw) return [];

    const parsed = JSON.parse(raw) as string[];

    if (Array.isArray(parsed)) {
      return parsed.map((r) => r.trim());
    }

    return [];
  } catch (error) {
    console.log('DetailView Error parsing role:', error);
    return [];
  }
};

const DetailView: React.FC = () => {
  const [roles, setRoles] = useState<string[]>(getCurrentRole());
  const location = useLocation();
  const defaultTab = location.state?.defaultTab || 'stammdaten';
  const [selectedTab, setSelectedTab] = useState<string>(defaultTab);

  useEffect(() => {
    const handleRoleChange = () => {
      const newRoles = getCurrentRole();
      setRoles(newRoles);
    };

    window.addEventListener('role-changed', handleRoleChange);
    window.addEventListener('storage', handleRoleChange);

    return () => {
      window.removeEventListener('role-changed', handleRoleChange);
      window.removeEventListener('storage', handleRoleChange);
    };
  }, [roles]);

  const hasRole = (roleName: string) =>
    roles.some((r) => r.toLowerCase() === roleName.toLowerCase());

  const hasPermission = ROLES.some((allowedRole) => hasRole(allowedRole));

  const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value as string);
  };

  return (
    <>
      {hasPermission ? (
        <>
          <h2 className="sectionTitle">{location.state?.name}</h2>
          <div className="container">
            <div className="header">
              <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
                <Tab icon={<PersonRegular />} value="stammdaten">
                  Stammdaten
                </Tab>
                <Tab icon={<TimerRegular />} value="zeitaufzeichnung">
                  Timetracking
                </Tab>
              </TabList>
              <Divider />
            </div>
            {selectedTab === 'stammdaten' && <Personaldata />}
            {selectedTab === 'zeitaufzeichnung' && <Timetracking />}
          </div>
        </>
      ) : (
        <div>Keine Berechtigung</div>
      )}
    </>
  );
};
export default DetailView;
